import React from 'react';
import { UpdateWorkspace } from '../../../../shared/types/workspaceTypes';
import styled from 'styled-components';
import { Headline } from '../../../../shared/styled-components/styled_text';
import { AlimTokPreview } from './AlimTokPreview';
import { GuidePopup } from './GuidePopup';

interface Props {
  data: UpdateWorkspace;
  handleClose?: () => void;
}

export const OnboardingStep1Preview: React.FC<Props> = ({ data, handleClose }) => {
  const [openDetail, setOpenDetail] = React.useState<boolean>(false);

  return (
    <Container className={'page-container'}>
      <SafeAreaContent>
        <Header>
          <button onClick={handleClose}>
            <CloseIcon />
          </button>
          <Headline size={'s'}>{`지원자가 ${openDetail ? '보는 안내 페이지' : '받는 알림톡'} 미리보기`}</Headline>
        </Header>
        <AlimTokPreview data={data} setOpenDetail={setOpenDetail} />
        {openDetail && <GuidePopup data={data} handleClose={() => setOpenDetail(false)} />}
      </SafeAreaContent>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  background-color: var(--background-1);
  z-index: 2000;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;

  padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);

  * {
    box-sizing: border-box;
  }
`;

const SafeAreaContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  position: relative;
`;

const Header = styled.div`
  width: 100%;
  height: 5.6rem;
  padding: 0 1.6rem 1.2rem;
  background-color: var(--background-1);
  border-bottom: 1px solid var(--border-color);

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1.2rem;
`;

const CloseIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  mask-image: url('/images/common/chevron.svg');
  mask-size: cover;
  mask-repeat: no-repeat;
  background-color: var(--content-color-primary);
`;
